import { faker } from '@faker-js/faker';
import { CountryCodes, Region } from '../types';

export const fakeRegionFactory = {
  createRegion: (region: Partial<Region> = {}): Region => ({
    country: CountryCodes.DE,
    zipCode: faker.address.zipCode('#####'),
    ...region,
  }),
};

export const fakeRegion: Region = fakeRegionFactory.createRegion();
